import { useState } from 'react'
import type { Notification } from '@ztechapps/common.contract'
import type { UseListResult } from '../useList'
import { useNotification } from './useNotification'

export type UseNotificationDropdownResult = {
  notifications: UseListResult<Notification>
  unreadCount: number
  loading: boolean
  handleToggleRead: (notification: Notification) => Promise<void>
  handleReadAll: () => Promise<void>
}

export const useNotificationDropdown = (): UseNotificationDropdownResult => {
  const [toggling, setToggling] = useState(false)

  const {
    notifications,
    unreadCount,
    handleUpdate,
    handleIsReadAll,
    loading: notificationLoading,
  } = useNotification({
    listProps: {
      limit: 10,
    },
  })

  const handleToggleRead = async (notification: Notification) => {
    try {
      setToggling(true)
      await handleUpdate({
        filter: { _id: notification._id },
        input: { isRead: !notification.isRead },
      })
    } finally {
      setToggling(false)
    }
  }

  return {
    notifications,
    unreadCount: unreadCount ?? 0,
    loading: toggling || notificationLoading || notifications?.loading,
    handleToggleRead,
    handleReadAll: handleIsReadAll,
  }
}
